exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ApiCardHeightAdjustment[data-v-b35fda68]{\n    height: unset;\n    width: unset;\n    border: none;\n}\n.integrationLogoAlignment[data-v-b35fda68]{\n    background-position: left !important;\n    margin: 2px unset unset 0px !important;\n    height: 20px !important;\n    background-size: contain !important;\n    /* margin-left: 0px !important; */\n}\n.active[data-v-b35fda68] {\n    background: #f0f3fb !important;\n}\n", ""]);

// exports
